import { ErrorInfo, ReactNode } from 'react';
import { ErrorBoundaryInner } from '@/components/ErrorBoundaryInner';
import { useEvents } from '@/talons';

interface Props {
  children: ReactNode;
}

function ErrorBoundary({ children }: Props) {
  const { registerEvent } = useEvents();

  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    registerEvent({
      tipoEvento: 'BOUNDARY',
      obsEvento: `Erro capturado pelo ErrorBoundary: ${error.message} ${error.stack}`,
      stEvento: 0,
    });
  };

  return (
    <ErrorBoundaryInner onError={handleError}>
      {children}
    </ErrorBoundaryInner>
  );
}

export default ErrorBoundary;
